import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	active: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	future: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementOptionSuggestedSprints: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	active: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.active',
		defaultMessage: 'Active',
		description:
			'This text is shown as a secondary label alongside a sprint name to indicate its state, in this case the sprint is active.',
	},
	future: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.future',
		defaultMessage: 'Future',
		description:
			'This text is shown as a secondary label alongside a sprint name to indicate its state, in this case the sprint is future.',
	},
	closed: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.closed',
		defaultMessage: 'Closed',
		description:
			'This text is shown as a secondary label alongside a sprint name to indicate its state, in this case the sprint is closed.',
	},
	refinementOptionSuggestedSprints: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.refinement-option-suggested-sprints',
		defaultMessage: 'Suggested Sprints',
		description: 'Suggested Sprints subtitle in issue navigator refinement dropdown',
	},
});
export default messages;
